export function RunePattern4({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 1300 1300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Rune Pattern</title>
      <g opacity="0.3">
        <g filter="url(#filter0_f_542_821)">
          <path
            d="M650.415 1172.2C938.992 1171.79 1172.6 937.527 1172.2 648.95C1171.79 360.373 937.526 126.763 648.949 127.168C360.373 127.573 126.763 361.838 127.168 650.415C127.572 938.992 361.838 1172.6 650.415 1172.2Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M280.319 358.54C323.008 358.48 357.565 323.825 357.506 281.136C357.446 238.448 322.791 203.89 280.102 203.95C237.413 204.01 202.856 238.664 202.916 281.353C202.975 324.042 237.63 358.6 280.319 358.54Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M126.246 727.712C168.935 727.652 203.492 692.997 203.432 650.308C203.372 607.619 168.718 573.062 126.029 573.121C83.3401 573.181 48.7824 607.836 48.8423 650.525C48.9021 693.214 83.5568 727.771 126.246 727.712Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M649.056 203.433C691.745 203.373 726.303 168.718 726.243 126.029C726.183 83.3402 691.528 48.7826 648.839 48.8424C606.151 48.9023 571.593 83.557 571.653 126.246C571.713 168.935 606.367 203.492 649.056 203.433Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M281.353 1096.45C324.042 1096.39 358.6 1061.73 358.54 1019.05C358.48 976.357 323.825 941.8 281.136 941.859C238.447 941.919 203.89 976.574 203.95 1019.26C204.01 1061.95 238.664 1096.51 281.353 1096.45Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M650.524 1250.52C693.213 1250.46 727.771 1215.81 727.711 1173.12C727.651 1130.43 692.997 1095.87 650.308 1095.93C607.619 1095.99 573.061 1130.65 573.121 1173.34C573.181 1216.02 607.836 1250.58 650.524 1250.52Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M1019.26 1095.41C1061.95 1095.36 1096.51 1060.7 1096.45 1018.01C1096.39 975.323 1061.73 940.765 1019.05 940.825C976.357 940.885 941.799 975.539 941.859 1018.23C941.919 1060.92 976.573 1095.47 1019.26 1095.41Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M1173.34 726.243C1216.02 726.184 1250.58 691.529 1250.52 648.84C1250.46 606.151 1215.81 571.594 1173.12 571.653C1130.43 571.713 1095.87 606.368 1095.93 649.057C1095.99 691.746 1130.65 726.303 1173.34 726.243Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M1018.23 357.505C1060.92 357.445 1095.47 322.791 1095.41 280.102C1095.35 237.413 1060.7 202.855 1018.01 202.915C975.322 202.975 940.764 237.63 940.824 280.318C940.884 323.007 975.539 357.565 1018.23 357.505Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M1000.62 297.755L297.755 298.741L298.74 1001.61L1001.61 1000.62L1000.62 297.755Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M1149.1 648.931L648.982 150.211L150.262 650.332L650.383 1149.05L1149.1 648.931Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M1033.56 264.729L1000.58 264.776L1000.62 297.755L1033.6 297.709L1033.56 264.729Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M297.709 265.761L264.729 265.807L264.776 298.787L297.755 298.74L297.709 265.761Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M126.271 626.491L102.385 650.444L126.338 674.33L150.224 650.377L126.271 626.491Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M298.74 1001.61L265.761 1001.66L265.807 1034.64L298.786 1034.59L298.74 1001.61Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M650.368 1149.13L626.482 1173.08L650.435 1196.97L674.321 1173.02L650.368 1149.13Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M648.901 102.711L625.015 126.664L648.968 150.55L672.854 126.597L648.901 102.711Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M1034.59 1000.58L1001.61 1000.62L1001.66 1033.6L1034.64 1033.56L1034.59 1000.58Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
          <path
            d="M1196.97 648.9L1173.02 625.014L1149.13 648.967L1173.08 672.853L1196.97 648.9Z"
            stroke="#F5D64E"
            strokeWidth="7"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M650.415 1172.2C938.992 1171.79 1172.6 937.527 1172.2 648.95C1171.79 360.373 937.526 126.763 648.949 127.168C360.373 127.573 126.763 361.838 127.168 650.415C127.572 938.992 361.838 1172.6 650.415 1172.2Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M280.319 358.54C323.008 358.48 357.565 323.825 357.506 281.136C357.446 238.448 322.791 203.89 280.102 203.95C237.413 204.01 202.856 238.664 202.916 281.353C202.975 324.042 237.63 358.6 280.319 358.54Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M126.246 727.712C168.935 727.652 203.492 692.997 203.432 650.308C203.372 607.619 168.718 573.062 126.029 573.121C83.3401 573.181 48.7824 607.836 48.8423 650.525C48.9021 693.214 83.5568 727.771 126.246 727.712Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M649.056 203.433C691.745 203.373 726.303 168.718 726.243 126.029C726.183 83.3402 691.528 48.7826 648.839 48.8424C606.151 48.9023 571.593 83.557 571.653 126.246C571.713 168.935 606.367 203.492 649.056 203.433Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M281.353 1096.45C324.042 1096.39 358.6 1061.73 358.54 1019.05C358.48 976.357 323.825 941.8 281.136 941.859C238.447 941.919 203.89 976.574 203.95 1019.26C204.01 1061.95 238.664 1096.51 281.353 1096.45Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M650.524 1250.52C693.213 1250.46 727.771 1215.81 727.711 1173.12C727.651 1130.43 692.997 1095.87 650.308 1095.93C607.619 1095.99 573.061 1130.65 573.121 1173.34C573.181 1216.02 607.836 1250.58 650.524 1250.52Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M1019.26 1095.41C1061.95 1095.36 1096.51 1060.7 1096.45 1018.01C1096.39 975.323 1061.73 940.765 1019.05 940.825C976.357 940.885 941.799 975.539 941.859 1018.23C941.919 1060.92 976.573 1095.47 1019.26 1095.41Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M1173.34 726.243C1216.02 726.184 1250.58 691.529 1250.52 648.84C1250.46 606.151 1215.81 571.594 1173.12 571.653C1130.43 571.713 1095.87 606.368 1095.93 649.057C1095.99 691.746 1130.65 726.303 1173.34 726.243Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M1018.23 357.505C1060.92 357.445 1095.47 322.791 1095.41 280.102C1095.35 237.413 1060.7 202.855 1018.01 202.915C975.322 202.975 940.764 237.63 940.824 280.318C940.884 323.007 975.539 357.565 1018.23 357.505Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M1000.62 297.755L297.755 298.741L298.74 1001.61L1001.61 1000.62L1000.62 297.755Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M1149.1 648.931L648.982 150.211L150.262 650.332L650.383 1149.05L1149.1 648.931Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M1033.56 264.729L1000.58 264.776L1000.62 297.755L1033.6 297.709L1033.56 264.729Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M297.709 265.761L264.729 265.807L264.776 298.787L297.755 298.74L297.709 265.761Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M126.271 626.491L102.385 650.444L126.338 674.33L150.224 650.377L126.271 626.491Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M298.74 1001.61L265.761 1001.66L265.807 1034.64L298.786 1034.59L298.74 1001.61Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M650.368 1149.13L626.482 1173.08L650.435 1196.97L674.321 1173.02L650.368 1149.13Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M648.901 102.711L625.015 126.664L648.968 150.55L672.854 126.597L648.901 102.711Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M1034.59 1000.58L1001.61 1000.62L1001.66 1033.6L1034.64 1033.56L1034.59 1000.58Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
        <path
          d="M1196.97 648.9L1173.02 625.014L1149.13 648.967L1173.08 672.853L1196.97 648.9Z"
          stroke="#F5D64E"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_542_821"
          x="30.3423"
          y="30.3424"
          width="1238.68"
          height="1238.68"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="7.5" result="effect1_foregroundBlur_542_821" />
        </filter>
      </defs>
    </svg>
  )
}
